import { Bank, Briefcase, Buildings, Coins, CurrencyBtc, Diamond } from '@phosphor-icons/react';

import { MoneyDisplay } from '../common/MoneyDisplay';
import { AccountAssetRow } from './AccountAssetRow';

const GROUP_ICONS = {
  conta: Bank,
  corretora: Briefcase,
  crypto: CurrencyBtc,
  ouro: Diamond,
  imobiliario: Buildings,
  outro: Coins,
};

/**
 * `.pen` → `ds/card/composition-group`: cartão por tipo de ativo — chip com
 * o ícone do tipo, nome, total à direita, separador, e a lista de linhas
 * (`AccountAssetRow`, um por ativo).
 */
export function AccountTypeGroup({ group, onEdit, onArchive }) {
  const Icon = GROUP_ICONS[group.id] || Coins;

  return (
    <section className="flex flex-col gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 shadow-[0_6px_16px] shadow-glass-shadow/[0.12] dark:shadow-glass-shadow/[0.45]">
      <div className="flex items-center justify-between gap-space-2">
        <div className="flex items-center gap-1.5">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-ds-sm bg-sage-tint text-sage-on-tint">
            <Icon size={14} aria-hidden />
          </span>
          <h3 className="type-title-card text-foreground">{group.label}</h3>
        </div>
        <MoneyDisplay
          value={group.totalEur}
          className="font-display text-type-display-stat font-bold text-foreground"
        />
      </div>

      <div className="h-px bg-border" aria-hidden />

      <ul className="flex flex-col gap-space-2-5">
        {group.items.map(({ account, balanceEur, liquidityLayer }) => (
          <li key={account.id} className="list-none">
            <AccountAssetRow
              account={account}
              balanceEur={balanceEur}
              liquidityLayer={liquidityLayer}
              onEdit={onEdit}
              onArchive={onArchive}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
